module.exports = __webpack_public_path__ + "media/images/favicon/primary/apple-icon-120x120-80805c7cd7ce2eaa616cf368e75329d5.png";